<template>
  <v-container fluid class="pa-0">
    <v-row align="center" dense class="mt-n2 mb-2">
      <v-col cols="12" sm="8" md="9">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          clearable
          dense
          outlined
          hide-details
          label="Buscar zona..."
          v-model="search"
          class="white rounded-lg"
        >
        </v-text-field>
      </v-col>
      <v-col v-if="distributorSelected" cols="12" sm="4" md="3" class="text-end d-flex justify-end align-center" :class="{ 'd-none': $vuetify.breakpoint.xsOnly }">
        <v-btn color="primary" @click="addZone" rounded small elevation="0">
          <v-icon left size="18">mdi-map-plus </v-icon>
          Agregar zona
        </v-btn>
      </v-col>
    </v-row>

    <!-- Mobile Floating Action Button (FAB) -->
    <v-btn
      v-if="$vuetify.breakpoint.xsOnly && distributorSelected"
      color="primary"
      dark
      fab
      fixed
      bottom
      right
      style="bottom: 80px; right: 16px; z-index: 5;"
      @click="addZone"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-row class="mt-n4">
      <v-col>
        <v-data-table
          width="100%"
          :height="$vuetify.breakpoint.smAndDown ? 'auto' : `calc(100vh - 400px)`"
          :headers="headers"
          :items="zones"
          fixed-header
          :items-per-page="5"
          class="elevation-1"
          no-data-text="No hay zonas disponibles"
          loading-text="Cargando zonas..."
          :page.sync="page"
          hide-default-footer
          :loading="fetchingData"
        >
          <template v-slot:body="{ items }">
            <template v-if="$vuetify.breakpoint.xsOnly">
              <v-container class="pa-2 px-0 bg-app">
                <v-row dense>
                  <v-col
                    cols="12"
                    v-for="item in items"
                    :key="item._id"
                    class="mb-2"
                  >
                    <v-card elevation="1" class="rounded-xl pa-4">
                      <div class="d-flex justify-space-between align-center mb-2">
                        <div class="d-flex align-center">
                          <v-avatar color="primary" size="40" class="mr-3">
                            <span class="white--text text-subtitle-1 font-weight-bold">
                              <v-icon dark>mdi-map-marker-radius</v-icon>
                            </span>
                          </v-avatar>
                          <div>
                            <div class="text-subtitle-1 font-weight-bold grey--text text--darken-4 line-height-tight">
                              {{ item.name }}
                            </div>
                            <div class="text-caption grey--text text--darken-1">
                              {{ item.city }}, {{ item.state }}
                            </div>
                          </div>
                        </div>
                        <v-menu :rounded="true" offset-y left>
                          <template v-slot:activator="{ attrs, on }">
                            <v-btn icon v-bind="attrs" v-on="on" small color="grey darken-1">
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item @click="updateZone(item)">
                              <v-list-item-title> Actualizar </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="deleteZoneRequest(item)">
                              <v-list-item-title class="error--text">Eliminar </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>

                      <v-divider class="my-2"></v-divider>

                      <v-row dense class="text-caption">
                        <v-col cols="6" class="py-1">
                          <div class="grey--text">C.P.</div>
                          <div class="font-weight-medium text-truncate">
                            {{ item.zipCode }}
                          </div>
                        </v-col>
                        <v-col cols="12" class="py-1 mt-1">
                          <div class="grey--text mb-1">Asesores externos</div>
                          <div
                            v-if="item.advisors && item.advisors.length != 0"
                          >
                            <v-chip
                              v-for="(advisor, index) in item.advisors"
                              :key="index"
                              small
                              color="primary"
                              text-color="white"
                              class="mr-1 mb-1 font-weight-bold"
                            >
                              {{ advisor }}
                            </v-chip>
                          </div>
                          <div class="font-weight-medium grey--text" v-else>Sin asesores externos</div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </template>
            <template v-else>
              <tbody>
                <tr v-for="item in items" :key="item._id">
                  <td>
                    <div class="d-flex align-center">
                      <v-avatar color="primary" size="36" class="mr-3">
                        <span class="white--text text-caption font-weight-bold">
                          <v-icon small dark>mdi-map-marker-radius</v-icon>
                        </span>
                      </v-avatar>
                      <div>
                        <div class="font-weight-bold grey--text text--darken-4 line-height-tight">
                          {{ item.name }}
                        </div>
                        <div class="text-caption grey--text text--darken-1">
                          {{ item.city }}, {{ item.state }}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>{{ item.state }}</td>
                  <td>{{ item.city }}</td>
                  <td>{{ item.zipCode }}</td>
                  <td>
                    <div v-if="item.advisors && item.advisors.length != 0" class="advisors-cell">
                      <v-chip
                        v-for="(advisor, index) in item.advisors"
                        :key="index"
                        small
                        color="secondary"
                        outlined
                        class="mr-1 mb-1 font-weight-medium"
                      >
                        {{ advisor }}
                      </v-chip>
                    </div>
                    <div v-else class="grey--text text--darken-1">Sin asesores externos</div>
                  </td>
                  <td>
                    <v-menu :rounded="true" offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn class="ma-0" v-bind="attrs" v-on="on" icon small>
                          <v-icon color="grey darken-1"> mdi-dots-vertical </v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="updateZone(item)">
                          <v-list-item-title> Actualizar </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="deleteZoneRequest(item)">
                          <v-list-item-title>Eliminar </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
              </tbody>
            </template>
          </template>
        </v-data-table>
        <v-pagination
          v-model="page"
          :length="numPages"
          total-visible="10"
          color="primary"
          class="mt-n2"
        ></v-pagination>
      </v-col>
    </v-row>
    <NewZone
      v-model="showNewZone"
      v-if="showNewZone"
      @fetchData="fetchZones()"
    />
    <UpdateZone
      v-model="showUpdateZone"
      v-if="showUpdateZone"
      @fetchData="fetchZones()"
    />
  </v-container>
</template>

<script>
//vuex
import { mapActions, mapMutations, mapState } from "vuex";
//components
import NewZone from "@/components/users/modals/NewZone.vue";
import UpdateZone from "@/components/users/modals/UpdateZone.vue";
export default {
  components: {
    NewZone,
    UpdateZone,
  },
  data: () => ({
    tabs: 0,

    zones: [],
    page: 1,
    numPages: 0,
    fetchingData: false,
    search: null,
    showNewZone: false,
    showUpdateZone: false,
  }),
  computed: {
    ...mapState("user", ["distributorSelected"]),
    headers() {
      const isMobile = this.$vuetify.breakpoint.xsOnly;
      const allHeaders = [
        { text: "Nombre", align: "start", sortable: false, value: "name" },
        { text: "Estado", value: "state" },
        { text: "Ciudad", value: "city" },
        { text: "C.P", value: "zipCode" },
        { text: "Asesores externos", value: "advisors" },
        { text: "Acciones", value: "actions" },
      ];

      if (isMobile) {
        return allHeaders.filter(h => ["name", "city", "actions"].includes(h.value));
      }
      return allHeaders;
    },
  },
  methods: {
    ...mapActions("zone", [
      "getZonesByDistributorPaged",
      "verifyUsers",
      "deleteZone",
    ]),
    ...mapMutations("zone", ["SET_ZONE_SELECTED"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    addZone() {
      this.showNewZone = true;
    },
    async deleteZoneRequest(zone) {
      try {
        let payloadVerify = {
          zoneId: zone._id,
        };
        let response = await this.verifyUsers(payloadVerify);
        if (!response) throw response;

        if (response.quantity == 0) {
          // delete zone since there are no users in the zone
          let payload = {
            zoneId: zone._id,
          };
          let response = await this.deleteZone(payload);
          console.log(response);
          if (!response) throw response;
          await this.fetchZones();
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Zona eliminada",
            timeout: 7000,
          });
        } else {
          // warn the user that there are users associated with that zone, the user must first change the zone before the zone is deleted
          this.SET_ALERT_TYPE({
            visible: true,
            type: "info",
            text: "Hay usuarios dentro de la zona, cambia la zona a los usuarios para poder eliminar.",
            timeout: 7000,
          });
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal eliminar zona",
          timeout: 5000,
        });
      }
    },
    usersInZone(zone) {},
    updateZone(zone) {
      this.SET_ZONE_SELECTED(zone);
      this.showUpdateZone = true;
    },
    async fetchZones() {
      try {
        let payload = {
          distributorId: this.distributorSelected
            ? this.distributorSelected._id
            : null,
          page: this.page,
          search: this.search,
        };
        let response = await this.getZonesByDistributorPaged(payload);
        if (!response) throw response;
        this.zones = response.zones;
        this.numPages = response.pages;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal cargar zonas",
          timeout: 5000,
        });
      }
    },
  },
  watch: {
    async distributorSelected() {
      await this.fetchZones();
    },
    async search() {
      this.page = 1;
      await this.fetchZones();
    },
    async page() {
      await this.fetchZones();
    },
  },
  async created() {
    await this.fetchZones();
  },
};
</script>

<style scoped>
.advisors-cell {
  white-space: normal;
  max-width: 260px;
}
</style>
